import { render } from "./CalendarModule.vue?vue&type=template&id=08032637&scoped=true"
import script from "./CalendarModule.vue?vue&type=script&lang=js"
export * from "./CalendarModule.vue?vue&type=script&lang=js"

import "./CalendarModule.vue?vue&type=style&index=0&id=08032637&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08032637"]])

export default __exports__